<template>
  <b-card
    class="boxNews mb-1"
    style="height: 100%; max-height: 500px; "
    no-body
  >

    <b-card-header class="backgroundCardHeaderHotView">
      <h3 class="card-title">
        <router-link
          :to="{ name: 'home-latest-news', params: { slug: 'tin-moi' } }"
          class="d-flex justify-content-between align-items-center"
          title="Tin mới"
        > <span class="tinmoi" />
          <span class="font-be-vietnam font-size20-be-vietnam text-dark font-weight-700 ml-1">Tin mới </span>
        </router-link>
      </h3>
    </b-card-header>
    <b-card-body class="px-0 py-1">
      <vue-perfect-scrollbar
        ref="refHotNewsPS"
        :settings="perfectScrollbarSettings"
        class="home-scroll-area"
      >
        <ul class="new-list px-1">
          <li
            v-for="(item) in items"
            :key="item.id"
            style="padding-bottom: 5px;"
          >
            <div class="d-flex">
              <!--

                2. Tin đã click màu ghi
              3. Tin hot màu đỏ tười có iconhot
            4. TIn đã lấy màu nâu đỏ có icon xanh
          5. Tin hot đã click màu ghi có icon hot
          6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
        -->
              <h3
                class="news-title d-flex"
                style="margin-bottom: 0;"
              >
                <router-link
                  :to="{ name: 'home-view', params: { id: item.id, slug: item.slug } }"
                  class="link  d-flex"
                  :title="item.title"
                >
                  <span :class="renderClassTitleHot(item)"> {{ item.title }}
                    <span
                      v-if="item.hot"
                      class="iconHotGif"
                    />
                    <span
                      v-if="item.is_get"
                      class="iconNewsRead"
                    /></span>
                  <!-- <span
                  class=" font-be-vietnam text-dark font-weight-500 trunc trunc-3"
                  :class="item.hot ? 'font-size14-red-be-vietnam' : 'font-size14-be-vietnam' "
                >{{ item.title }}</span> -->
                </router-link>
              </h3>
              <!-- <div class="news-icon col-2 d-flex flex-row justify-content-end align-content-center ">
              <span
                v-for=" (type, key) in item.content_type"
                :key="key"
              >
                <span
                  v-if="type === 'audio'"
                  class="iconaudio"
                />
                <span
                  v-if="type === 'photo'"
                  class="iconphoto"
                />
                <span
                  v-if="type === 'video'"
                  class="iconvideo"
                />
              </span>

            </div> -->
            </div>
            <div class="news-icon d-flex flex-wrap font-be-vietnam">
              <div class="w-35">
                <span
                  v-for=" (type, key) in item.content_type"
                  :key="key"
                  class=" mr-0"
                >
                  <span
                    v-if="type === 'audio'"
                    class="iconAudioBlue  mr-0"
                  />
                  <span
                    v-if="type === 'photo'"
                    class="iconPhotoBlue  mr-0"
                  />
                  <span
                    v-if="type === 'video'"
                    class="iconVideoBlue  mr-0"
                  />
                </span>
              </div>
              <div class="w-65 ml-auto text-right">
                <span>{{ (item.timeago) }}</span>
                <span
                  v-if="item.unit"
                  class="icon"
                  style="padding-left: 10px;"
                />
                <span v-if="item.unit">{{ showListPart(item.unit) }}</span>
              </div>
            </div>
          </li>
          <!-- <li>
          <div class="col-12 d-flex">
            <div class="col-10 p-0">

              <h3 class="news-title ">
                <router-link
                  :to="{ name: 'post-view', params: { id: 1, slug: 1 } }"
                  class="link d-flex"
                  title="Tiêu đề"
                >
                  <span class="iconHot pt-2 align-items-center" /> <span
                    class=" font-size14-red-be-vietnam pt-2 font-be-vietnam "
                  >TC - Người dân có thể đóng, nộp BHXH tự
                    nguyện, BHYT hộ gia đình qua hình thức online từ ngày 1/6</span> </router-link>
              </h3>
            </div>
            <div class="news-icon col-2 d-flex flex-row justify-content-end ">
              <span class="iconphoto" />
            </div>
          </div>
          <div class="news-icon col-12 p-0 d-flex flex-row font-be-vietnam">

            <span class="icon ml-1">17 phút</span>
            <span
              class="icon"
              style="padding-left: 10px;"
            />

            <span>VoV,TN,MT</span>
          </div>
        </li> -->
        </ul>
      </vue-perfect-scrollbar>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard,
  BCardHeader,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BImg,
  BLink,
} from 'bootstrap-vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { timeago } from '@/libs/helper';

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BImg,
    BRow,
    BCol,
    BButton,
    BLink,
    BCardHeader,
    VuePerfectScrollbar,
  },
  props: {
    items: {
      type: Array,
      default: Array,
    },
  },

  setup(props, context) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };
    return {
      perfectScrollbarSettings,
    }
  },
  methods: {
    resolveTimeago(time) {
      return timeago(time);
    },
    showListPart(str) {
      return str.split(',').slice(0, 3).join(',');
    },
    renderClassTitleHot(item) {
      // 1. Tin bình thường mầu đen

      // 2. Tin đã click màu ghi
      // 3. Tin hot màu đỏ tười có iconhot
      // 4. TIn đã lấy màu nâu đỏ có icon xanh
      // 5. Tin hot đã click màu ghi có icon hot
      // 6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
      let classTitle = 'class_title_normall';
      if (item.hot) {
        if (item.is_get) { // đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_get_view'
          } else {
            classTitle = 'class_title_hot_get_notview'
          }
        } else if (!item.is_get) { // tin chưa lấy những có thể đọc hoặc chưa đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_notget_view'
          } else {
            classTitle = 'class_title_hot_notget_notview' // tin hot chưa lấy chưa đọc
          }
        }
      } else if (!item.hot) {
        if (item.is_get) { // tin đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_nothot_get_view'
          } else {
            classTitle = 'class_title_nothot_notget_notview'
          }
        } else if (!item.is_get) {
          if (item.is_view) { // tin bt nhưng đã xem chưa lấy
            classTitle = 'class_title_nohot_notget_view'
          } else {
            classTitle = 'class_title_nohot_notget_notview'
          }
        }
      }

      return classTitle;
    },
  },
}
</script>
<style lang="scss">
.home-scroll-area {
  position: relative;
  height: 100%;
}
</style>
